import { render, staticRenderFns } from "./Matching.vue?vue&type=template&id=437aa3d8&scoped=true&"
import script from "./Matching.vue?vue&type=script&lang=js&"
export * from "./Matching.vue?vue&type=script&lang=js&"
import style0 from "./Matching.vue?vue&type=style&index=0&id=437aa3d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437aa3d8",
  null
  
)

export default component.exports